import { executeGet } from '../common/apiCaller'
import { GetAreasDto } from '../dto/areasDto'

const apiName = 'public'
const apiPath = '/areas'

export const executeGetAreas = () => {
  return executeGet<GetAreasDto[]>(apiName, apiPath)
}
